// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"App__wrapper__3QGUb","Main":"App__Main__MCIv-","Stage":"App__Stage__3YCW7"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 45
// module chunks = 0